import React from 'react';

/* ─────────────────────────────────────────────────────────
 * CONTEXT CARDS (Knowledge Chunks)
 * Retrieved knowledge chunks with source headers & scores.
 * ───────────────────────────────────────────────────────── */

export default function ContextCards({
  cards = [
    {
      source: "Cold-chain SOP Manual #402",
      score: "0.98 similarity",
      snippet: "Cold-chain certification must be verified before a new dairy or cone vendor can be added to the automated reorder workflow."
    },
    {
      source: "Q4 Velocity Performance Table",
      score: "0.92 similarity",
      snippet: "Pistachio +18%, Vanilla +6%, Rocky Road -11%; retire flavors falling below 40 scoops weekly average."
    }
  ]
}: {
  cards?: { source: string; score?: string; snippet: string }[];
}) {
  return (
    <div className="flex flex-col gap-2 my-2 w-full max-w-105">
      <div className="text-[11px] font-bold uppercase tracking-wider text-ink-3">
        Retrieved Knowledge Chunks ({cards.length})
      </div>
      {cards.map((c, i) => (
        <div
          key={i}
          className="flex flex-col gap-1 rounded-[10px] bg-surface p-3 shadow-hairline border border-line hover:border-line-strong transition-colors"
        >
          <div className="flex items-center justify-between text-xs">
            <span className="font-semibold text-ink flex items-center gap-1.5">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-accent">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
              {c.source}
            </span>
            {c.score && (
              <span className="font-mono text-[10.5px] text-ink-3 bg-field px-1.5 py-0.5 rounded-[4px]">
                {c.score}
              </span>
            )}
          </div>
          <div className="text-[12.5px] text-ink-2 leading-relaxed">
            "{c.snippet}"
          </div>
        </div>
      ))}
    </div>
  );
}
